<template>
    <div>
        <a-spin :spinning="spinning">
            <textarea :id="id" :name="name"></textarea>
        </a-spin>
        <Upload :width="0" :height="0" ref="uploadRef" :selectAll="true" :show="false" :type="type"></Upload>
    </div>
</template>
<script>
export default {
    props: {
        height: {
            type: String,
            default: "400px",
        },
        data: {
            type: String,
            default: "",
        },
        disable: {
            type: Boolean,
            default: false
        }
    },
    mounted() {
        this.spinning = true
        const self = this;
        // 渲染编辑器
        self.ckeditor = window.CKEDITOR.replace(this.name, {
            height: self.height,
            readOnly: self.disable
        }); //定义编辑器的高度

        // 监听内容变更事件
        self.ckeditor.on("change", function () {
            self.$emit("valueHtmlChange", {
                value: self.ckeditor.getData()
            });
        });
        // 绑定图片上传方法
        self.ckeditor.initUpload = this.initUpload

        // 设置初始内容
        this.timer = setTimeout(() => {
            self.ckeditor.setData(this.data);
            this.spinning = false
        }, 1500)
    },
    data: function () {
        return {
            id: parseInt(Math.random() * 10000).toString(),
            name: parseInt(Math.random() * 10000).toString(),
            ckeditor: null,
            type: '',
            timer: null,
            spinning: false
        };
    },
    beforeUnmount() {
        clearTimeout(this.timer)
    },
    watch: {
        // 监听prop的变化，更新ckeditor中的值
        data: {
            handler(neww) {
                if (this.data !== this.ckeditor.getData() && this.ckeditor) {
                    this.ckeditor.setData(this.data);
                }
            },
            immdiate: true
        },
        disable(val){
            this.ckeditor.setReadOnly(val)
        }
    },
    methods: {
        initUpload(ckeditor, type) {
            this.type = type
            this.$nextTick(() => {
                this.$refs.uploadRef.openModalEditor(ckeditor)
            })
        }
    }
};
</script>
<style scoped></style>